import * as React from 'react';

import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface IBVSpinLoader {
    style?: any
}

const BVSpinLoader: React.FunctionComponent<IBVSpinLoader> = ({ style }) => (
    <Spin indicator={<LoadingOutlined style={style} />} />
);

export default BVSpinLoader;